import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import {
  ErrorCallback,
  SuccessCallback,
} from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { normalizeEmptyResponseToSuccessResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/infrastructure';
import { IAuthorizationsRepository } from '../entities/IAuthorizationsRepository';
import { ConfirmOTPResponseBody } from '../entities/ConfirmOTPResponseDTO';
import { FallbackOTPResponseBody } from '../entities/FallbackOTPResponseDTO';
import { ResendCodeResponseBody } from '../entities/ResendCodeResponseDTO';
import { VerifyEmailResponseBody } from '../entities/VerifyEmailResponseDTO';

class AuthorizationsRepositoryImpl implements IAuthorizationsRepository {
  constructor() {
    this.ConfirmOTP = this.ConfirmOTP.bind(this);
    this.FallbackToOTP = this.FallbackToOTP.bind(this);
    this.ResendCode = this.ResendCode.bind(this);
    this.VerifyEmail = this.VerifyEmail.bind(this);
    this.WebAuthorization = this.WebAuthorization.bind(this);
  }

  WebAuthorization(data: GenericObject): Promise<{ status: string }> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/devices/web/authorizations/${data.authorizationId}/status`,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  ConfirmOTP(
    data: GenericObject,
    successCallback: SuccessCallback,
    errorCallback: ErrorCallback,
  ): Promise<ConfirmOTPResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'PUT',
        url: `/secure-web/api/private/devices/authorizations/otp/${data.dynamicPath}`,
        data: data.data,
        nextCallback: successCallback,
        onErrorCallback: errorCallback,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  FallbackToOTP(data: GenericObject): Promise<FallbackOTPResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: `/secure-web/api/private/devices/authorizations/${data.authorizationId}/fallback`,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  ResendCode(data: GenericObject): Promise<ResendCodeResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: `/secure-web/api/private/devices/authorizations/${data.authorizationId}/resend`,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  VerifyEmail(data: { token: string }): Promise<VerifyEmailResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: `/api/public/users/email`,
        params: { token: data.token },
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }
}

export { AuthorizationsRepositoryImpl };
